import Main from '../components/views/main/Main.vue'
// import Dashboard from '../components/views/dashboard/Dashboard.vue'
// import profileRoutes from './profile.route'
import roles from './roles.route'
import devicesRoutes from './devices.route'
import userRoutes from './users.route'
import regionRoutes from './region.route'
import vehicleRoutes from './vehicles.route'
import driverRoutes from './driver.route'
import siteRoutes from './sites.route'
import tripRoutes from './trips.route'
import tripRouteRoutes from './tripRoute.route'
import salesdataRoutes from './salesdata.route'
import reportgenerationRoutes from './reportgeneration.route'
import schedulereportRoutes from './schedulereport.route'
import dashboardRoutes from './dashboard.route'
import VehicleStatusRoutes from './VehicleStatus.route'
import technicianRoutes from './technician.route'
import registerRoutes from './register.route'
import profileRoutes from './profile.route'
import operatorreportRoutes from './operatorreport.route'
import complianceReportRoutes from './complianceReport.route'
import tripgroupRoute from './trip-group.route'

import hcvDetailsRooutes from './hcvdetails.route'

// import auditLogRoutes from './audit-logs.route'

const routes = [{
    path: '/',
    component: Main,
    children: [
        // {
        // 	path: 'dashboard',
        // 	alias: '',
        // 	component: Dashboard,
        // 	name: 'Dashboard',
        // 	meta: {
        // 		description: 'Overview of app',
        // 		title: 'Dashboard',
        // 		requiresAuth: true
        // 	}
        // },
        // {
        // 	path: 'profile',
        // 	component: Profile,
        // 	name: 'Profile',
        // 	meta: {
        // 		description: 'Profile details',
        // 		title: 'Profile',
        // 		requiresAuth: true
        // 	}
        // },
        ...siteRoutes,
        ...driverRoutes,
        ...vehicleRoutes,
        ...devicesRoutes,
        ...regionRoutes,
        ...userRoutes,
        ...roles,
        ...tripRoutes,
        ...tripRouteRoutes,
        ...salesdataRoutes,
        ...reportgenerationRoutes,
        ...schedulereportRoutes,
        ...dashboardRoutes,
        ...VehicleStatusRoutes,
        ...technicianRoutes,
        ...registerRoutes,
        ...profileRoutes,
        ...operatorreportRoutes,
        ...complianceReportRoutes,
        ...tripgroupRoute,
        ...hcvDetailsRooutes

    ]
}]

export default routes


// WEBPACK FOOTER //
// ./src/routes/main.route.js